import { Step } from "react-joyride";

const isAccordionExpanded = (el: Element | null): boolean =>
  !!el?.closest(".MuiAccordion-root.Mui-expanded");

const waitForExpanded = (selector: string, timeoutMs = 2000): Promise<void> =>
  new Promise((resolve) => {
    if (isAccordionExpanded(document.querySelector(selector))) {
      resolve();
      return;
    }

    const observer = new MutationObserver(() => {
      if (isAccordionExpanded(document.querySelector(selector))) {
        observer.disconnect();
        resolve();
      }
    });
    observer.observe(document.body, { attributes: true, attributeFilter: ["class"], subtree: true });

    setTimeout(() => {
      observer.disconnect();
      resolve();
    }, timeoutMs);
  });

const openFirstProposalTerm = async () => {
  if (isAccordionExpanded(document.querySelector(".tour-proposal-placeholders"))) return;
  (document.querySelector(".tour-proposal-term-summary") as HTMLElement | null)?.click();
  await waitForExpanded(".tour-proposal-placeholders");
};

const proposalSettingsPageTourSteps: Step[] = [
  {
    target: ".tour-proposal-format",
    content:
      "Choose a default format for your Proposals. You may still choose a different format when sending your Proposals.",
  },
  {
    target: ".tour-id-starting-number",
    content:
      "The starting number for your Proposals. This number then will increase sequentially with each subsequent Proposal (8755, 8756, etc.).",
  },
  {
    target: ".tour-id-prefix",
    content:
      "An optional prefix to add to your Proposal IDs. For example, if you add a prefix of ‘26’ and you are on Proposal 8755, the number will show as 26-8755.",
  },
  {
    target: ".tour-proposal-color",
    content: "Choose the background color you would like. This only applies to the Branded Proposal format.",
  },
  {
    target: ".tour-layout-content-settings",
    content:
      "Select which default Proposal Terms you would like to include on your Proposals. You can add and remove terms when sending any Proposal.",
  },
  {
    target: ".tour-proposal-terms",
    content:
      "Contains the legal language to include with your proposals. Expand each section to edit the text box with your Terms.",
  },
  {
    target: ".tour-add-proposal-terms-button",
    content: "Create additional Terms that may be added to your Proposals.",
  },
  {
    target: ".tour-proposal-placeholders",
    content:
      "These Placeholders are substitutes for text or numbers that will be automatically replaced in your Terms. A Proposal will have its Placeholder text switched with the specific text or numbers on the Proposal, giving a more personalized experience.",
    before: openFirstProposalTerm,
  },
];

export default proposalSettingsPageTourSteps;
